// @ts-nocheck
import React from 'react';
import { ApplyPluginsType } from '/home/ZCIPClient/workpath/164805/code/code/promotion-frontend/promotionh5DXP/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';

export function getRoutes() {
  const routes = [
  {
    "path": "/",
    "component": require('@/layouts/BaseLayout').default,
    "routes": [
      {
        "path": "/",
        "component": require('@/pages/LuckyDrawHome').default,
        "exact": true,
        "title": "game"
      },
      {
        "path": "/luckyDraw",
        "component": require('@/pages/LuckyDrawHome').default,
        "exact": true
      },
      {
        "path": "/rules",
        "exact": true,
        "component": require('@/pages/Rules').default
      },
      {
        "path": "/memberShipCenter",
        "exact": true,
        "component": require('@/pages/MemberShipCenter/pages/MemberShipIndexStatic').default
      },
      {
        "path": "/memberShipCenterMyRewards",
        "exact": true,
        "component": require('@/pages/MemberShipCenter/pages/MemberMyRewards').default
      },
      {
        "path": "/memberShipCenterMyRewardsNew",
        "exact": true,
        "component": require('@/pages/MemberShipCenter/pages/MemberMyRewardsNew').default
      },
      {
        "path": "/memberShipCenterMyRewardsWeb",
        "exact": true,
        "component": require('@/pages/MemberShipCenter/pages/MemberMyRewardsWeb').default
      },
      {
        "exact": true,
        "path": "/memberShipCenterRewardDetail",
        "component": require('@/pages/MemberShipCenter/pages/RewardDetailMedal').default
      },
      {
        "exact": true,
        "path": "/memberMyRewardsDetail",
        "component": require('@/pages/MemberShipCenter/pages/MemberMyRewardsDetail').default
      },
      {
        "exact": true,
        "path": "/memberSuccessPage",
        "component": require('@/pages/MemberShipCenter/pages/MemberSuccessPage').default
      },
      {
        "path": "/NewRewardDetail",
        "exact": true,
        "component": require('@/pages/RewardDetailNew').default
      },
      {
        "exact": true,
        "path": "/memberShipLevelGuide",
        "component": require('@/pages/MemberShipCenter/pages/MemberShipLevelGuide').default
      },
      {
        "path": "/pointshop/pointsH5",
        "component": require('@/pages/PointShop/Home').default,
        "routes": [
          {
            "path": "/pointshop/pointsH5/modal",
            "component": require('@/pages/PointShop/Home/components/ModalLayer').default,
            "routes": [
              {
                "path": "/pointshop/pointsH5/modal/history",
                "exact": true,
                "component": require('@/pages/PointShop/PointHistory').default
              },
              {
                "path": "/pointshop/pointsH5/modal/PointExchange",
                "exact": true,
                "component": require('@/pages/PointExchange').default,
                "title": "point exchange"
              },
              {
                "path": "/pointshop/pointsH5/modal/order",
                "exact": true,
                "component": require('@/pages/PointShop/Order').default
              },
              {
                "path": "/pointshop/pointsH5/modal/myVoucher",
                "exact": true,
                "component": require('@/pages/PointShop/MyVoucher').default
              },
              {
                "exact": true,
                "path": "/pointshop/pointsH5/modal/details/:id",
                "component": require('@/pages/PointShop/OfferDetails').default
              },
              {
                "path": "/pointshop/pointsH5/modal/orderConfirmation",
                "exact": true,
                "component": require('@/pages/PointShop/OrderConfirmation').default
              }
            ]
          }
        ]
      },
      {
        "exact": true,
        "path": "/pointshop/pointsTransfer",
        "component": require('@/pages/PointShop/PointsTransfer').default
      },
      {
        "exact": true,
        "path": "/pointshop/myVoucher",
        "component": require('@/pages/PointShop/MyVoucher').default
      },
      {
        "exact": true,
        "path": "/pointshop/voucherDetail",
        "component": require('@/pages/PointShop/VoucherDetail').default
      },
      {
        "exact": true,
        "path": "/pointshop/redeemList",
        "component": require('@/pages/PointShop/RedeemList').default
      },
      {
        "exact": true,
        "path": "/pointshop/order",
        "component": require('@/pages/PointShop/Order').default
      },
      {
        "exact": true,
        "path": "/pointshop/history",
        "component": require('@/pages/PointShop/PointHistory').default
      },
      {
        "exact": true,
        "path": "/pointshop/allcategories",
        "component": require('@/pages/PointShop/PointShopHome/AllCategories').default
      },
      {
        "exact": true,
        "path": "/pointshop/shoplist/:id",
        "component": require('@/pages/PointShop/ShopList').default
      },
      {
        "exact": true,
        "path": "/pointshop/details/:id",
        "component": require('@/pages/PointShop/OfferDetails').default
      },
      {
        "exact": true,
        "path": "/pointshop/orderConfirmation",
        "component": require('@/pages/PointShop/OrderConfirmation').default
      },
      {
        "exact": true,
        "path": "/pointshop/successful",
        "component": require('@/pages/PointShop/SuccessfulPage').default
      },
      {
        "exact": true,
        "path": "/pointshop/claimSuccessfull",
        "component": require('@/pages/PointShop/ClaimSuccessfull').default
      },
      {
        "exact": true,
        "path": "/pointshop/successfulNew",
        "component": require('@/pages/PointShop/SuccessfulPageNew').default
      },
      {
        "exact": true,
        "path": "/postPaidC2CHistory",
        "component": require('@/pages/PostPaidC2C/History').default
      },
      {
        "exact": true,
        "path": "/postPaidC2CDetail",
        "component": require('@/pages/PostPaidC2C/Detail').default
      },
      {
        "exact": true,
        "path": "/postPaidC2CMyReward",
        "component": require('@/pages/PostPaidC2C/MyReward').default
      },
      {
        "exact": true,
        "path": "/PointExchange",
        "component": require('@/pages/PointExchange').default,
        "title": "point exchange"
      },
      {
        "exact": true,
        "path": "/pointshop/pointsConversion",
        "component": require('@/pages/PointShop/PointsConversion').default
      },
      {
        "exact": true,
        "path": "/pointshop/SuccessPage",
        "component": require('@/pages/PointShop/SuccessPage').default
      },
      {
        "path": "/utm/:id",
        "component": require('@/pages/Utm').default,
        "exact": true
      },
      {
        "path": "/fam/:id",
        "component": require('@/pages/Utm').default,
        "exact": true
      },
      {
        "path": "/hilife/:id",
        "component": require('@/pages/Utm').default,
        "exact": true
      },
      {
        "path": "/pageBuilder",
        "exact": true,
        "component": require('@/pages/PageBuilder').default
      }
    ]
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
